export default __webpack_public_path__ + "static/media/detail_big_13_5.dc4c44bd.jpg";